
export function ImageCopyright({image_copyright }) {
   return <>{image_copyright && (<span className="image__copyright">{image_copyright}</span>)}</>
}


